import { Address } from '@frontend/api';

export const areSameAddresses = (a: Address, b: Address) => {
  return (
    a.address1 === b.address1 &&
    a.address2 === b.address2 &&
    a.city === b.city &&
    a.country.abbr === b.country.abbr &&
    a.postalCode === b.postalCode &&
    a.state?.abbr === b.state?.abbr
  );
};
